{
  "appName": "10275",
  "entryFile": "./app-entry.jsx",
  "entryName": "10275-edu-benefits",
  "rootUrl": "/school-administrators/commit-principles-of-excellence-form-22-10275",
  "productId": "7351a2b9-33f8-4b0e-9ed5-8db869276135"
}
